import * as React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Slider from '@mui/material/Slider';
import Input from '@mui/material/Input';


const styles = {
    slider: {
      width: '80%',
    },
    title: {
        fontFamily: 'Roboto Light',
        fontSize: 12,
      },
    markLabel: {
      fontFamily: 'Roboto Slab', // Set the font family to Roboto
      fontSize: 10, // Adjust the font size as needed
    },
    thumb: {
    backgroundColor: '#790096', // Set the thumb color to #404040
  },
  track: {
    backgroundColor: '#790096', // Set the track color to #404040
  },
  root: {
    fontFamily: 'Roboto Slab', // Set font to Roboto Mono
    fontSize: 12, // Set font size to 10 (or adjust as needed)
  },
  };

const marks: any = [];
  for (let year = 1890; year <= 2023; year += 15) {
    marks.push({ value: year, label: year });
  }


export interface InputSliderProps {
  title: string
  min_value: any;
  step_size: number;
  max_value: any;
  default_value: any;
  onChange: (axisType:number[]) => void;
}

const RangeSlider: React.FC<InputSliderProps> = ({
  title,
  min_value,
  step_size,
  max_value,
  onChange
}) => {

  const [value, setValue] =  React.useState<number[]>(
    [1889,2023],
  );



  const handleSliderChange = (event: any, newValue: any ) => {
    setValue(newValue);
    onChange(newValue)
  };

  const handleInputChange_min = (event: React.ChangeEvent<HTMLInputElement>) => {
    console.log(value)
    console.log(Number(event.target.value))
    setValue([Number(event.target.value), value[1]]);
    onChange([Number(event.target.value), value[1]]);
  };

  const handleInputChange_max = (event: React.ChangeEvent<HTMLInputElement>) => {
    console.log(value)
    console.log(Number(event.target.value))
    setValue([value[0], Number(event.target.value)]);
    onChange([value[0], Number(event.target.value)]);
  };

  const handleBlur_min = () => {
    if (value[0] < min_value) {
      setValue([min_value, value[1]]);
      onChange([min_value, value[1]]);

    } else if (value[0] >= value[1] ) {
        setValue([value[1] - 5, value[1]]);
        onChange([value[1] - 5, value[1]]);

    }
  };

  const handleBlur_max = () => {
    if (value < min_value) {
      setValue(min_value);
    } else if (value > max_value) {
      setValue(max_value);
    }
  };




  return (
    <Box sx={{ width: "80%" }}>
      <Typography id="input-slider"  gutterBottom sx={styles.title}>
        {title}
      </Typography>
      <Grid container item xs={12}>
        <Slider
            value={value}
            onChange={handleSliderChange}
            aria-labelledby="input-slider"
            min={min_value}
            max={max_value}
            step={step_size}
            marks={marks}
            sx={{
                '& .MuiSlider-markLabel': styles.markLabel, // Apply the custom styles to the mark labels
                '& .MuiSlider-thumb': styles.thumb, // Apply the custom styles to the thumb
                '& .MuiSlider-track': styles.track, // Apply the custom styles to the track
              }}
          />
        </Grid>
        <Grid container item xs={12}>

            <Grid xs={3}>
                <Input
                    value={value[0]}
                    size="medium"
                    onChange={handleInputChange_min}
                    onBlur={handleBlur_min}
                    inputProps={{
                    step: step_size,
                    min: min_value,
                    max: max_value,
                    type: 'number',
                    'aria-labelledby': 'input-slider',
                    }}
                    sx={styles.root} 

                />
            </Grid>
            <Grid xs={6}>
            </Grid>
            <Grid xs={3}>
            <Input
                value={value[1]}
                size="small"
                onChange={handleInputChange_max}
                onBlur={handleBlur_max}
                inputProps={{
                step: step_size,
                min: min_value,
                max: max_value,
                type: 'number',
                'aria-labelledby': 'input-slider',
                }}
                sx={styles.root} 
            />
            </Grid>
        </Grid>
    </Box>
  );
}

export default RangeSlider;
